<template>
  <pc-client-side-navigation-item
    id="userSettingsNavigationItem"
    icon="pc-entity-user"
    title="User settings"
    :selected="activeItem == 'userSettings'"
    to="/user-settings"
    :no-tooltips="sideMenuIsExpanded"
    data-id="9d4f13c7e08b42a6b719fc35a8e2d06b"
  ></pc-client-side-navigation-item>
</template>

<script>
import PcClientSideNavigationItem from "@/client/components/layout/PcClientSideNavigationItem";

export default {
  components: {
    PcClientSideNavigationItem,
  },

  props: {
    activeItem: {
      type: String,
      required: false,
      default: "",
    },
    sideMenuIsExpanded: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style lang="scss"></style>
